export default __webpack_public_path__ + "static/media/hamster.62635368.ogg";